import React from 'react';
import { Users, DollarSign, TrendingUp, AlertCircle, CheckCircle, Clock, BarChart, Settings, FileText, Shield, Activity, Zap } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
import { useNavigate } from 'react-router-dom';
export function SuperAdminDashboard() {
  const navigate = useNavigate();
  const stats = [{
    label: 'Total Anggota',
    value: '2.450',
    trend: '+12% dari bulan lalu',
    trendUp: true,
    icon: Users,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }, {
    label: 'Menunggu Verifikasi',
    value: '23',
    trend: 'Perlu review',
    trendUp: false,
    icon: Clock,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Pendapatan Bulanan',
    value: 'Rp 50 Juta',
    trend: '+8% dari bulan lalu',
    trendUp: true,
    icon: DollarSign,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Chapter Aktif',
    value: '12',
    trend: '2 baru kuartal ini',
    trendUp: true,
    icon: Activity,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }];
  const systemHealth = [{
    metric: 'Waktu Respon API',
    value: '45ms',
    status: 'good'
  }, {
    metric: 'Beban Database',
    value: '32%',
    status: 'good'
  }, {
    metric: 'Tingkat Error',
    value: '0.02%',
    status: 'good'
  }, {
    metric: 'Uptime',
    value: '99.98%',
    status: 'good'
  }];
  const recentActivities = [{
    user: 'Budi Santoso',
    action: 'membuat acara baru',
    target: 'Workshop React',
    time: '5 menit lalu',
    type: 'event'
  }, {
    user: 'Siti Nurhaliza',
    action: 'menyetujui keanggotaan',
    target: 'John Doe',
    time: '15 menit lalu',
    type: 'approval'
  }, {
    user: 'Ahmad Wijaya',
    action: 'membuat laporan',
    target: 'Analitik Bulanan',
    time: '1 jam lalu',
    type: 'report'
  }, {
    user: 'Sistem',
    action: 'backup selesai',
    target: 'Database',
    time: '2 jam lalu',
    type: 'system'
  }];
  const pendingApprovals = [{
    id: 1,
    name: 'PT Tech Indonesia',
    type: 'Organisasi',
    date: '2 hari lalu',
    status: 'pending'
  }, {
    id: 2,
    name: 'Jane Smith',
    type: 'Individu',
    date: '3 hari lalu',
    status: 'pending'
  }, {
    id: 3,
    name: 'Bandung Dev Community',
    type: 'Chapter',
    date: '5 hari lalu',
    status: 'pending'
  }];
  const handleApprove = (id: number) => {
    if (confirm('Apakah Anda yakin ingin menyetujui permohonan ini?')) {
      alert(`Permohonan #${id} telah disetujui`);
    }
  };
  const handleReject = (id: number) => {
    const reason = prompt('Alasan penolakan:');
    if (reason) {
      alert(`Permohonan #${id} ditolak. Alasan: ${reason}`);
    }
  };
  return <div className="min-h-screen bg-white" data-id="element-773">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-774">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-775">
          <div data-id="element-776">
            <div className="flex items-center gap-2 sm:gap-3 mb-2" data-id="element-777">
              <h1 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-neutral-900" data-id="element-778">
                Dasbor Super Admin
              </h1>
              <Badge className="bg-error text-white font-semibold text-xs" data-id="element-779">
                SUPER ADMIN
              </Badge>
            </div>
            <p className="text-sm sm:text-base text-neutral-600" data-id="element-780">
              Gambaran lengkap sistem dan manajemen
            </p>
          </div>
          <div className="flex gap-2 sm:gap-3" data-id="element-781">
            <Button variant="secondary" size="sm" onClick={() => navigate('/admin/settings')} className="flex-1 sm:flex-none" data-id="element-782">
              <Settings className="w-4 h-4 sm:mr-2" data-id="element-783" />
              <span className="hidden sm:inline" data-id="element-784">Pengaturan</span>
              <span className="sm:hidden" data-id="element-785">Setting</span>
            </Button>
            <Button size="sm" onClick={() => navigate('/admin/reports')} className="flex-1 sm:flex-none" data-id="element-786">
              <FileText className="w-4 h-4 sm:mr-2" data-id="element-787" />
              <span data-id="element-788">Laporan</span>
            </Button>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-789">
          {stats.map((stat, i) => <Card key={i} data-id="element-790">
              <CardContent className="p-4 sm:p-6" data-id="element-791">
                <div className="flex justify-between items-start mb-3 sm:mb-4" data-id="element-792">
                  <div className={`p-2 sm:p-3 rounded-lg ${stat.bgColor}`} data-id="element-793">
                    <stat.icon className={`w-5 h-5 sm:w-6 sm:h-6 ${stat.color}`} data-id="element-794" />
                  </div>
                  {stat.trendUp ? <TrendingUp className="w-4 h-4 text-success" data-id="element-795" /> : <AlertCircle className="w-4 h-4 text-error" data-id="element-796" />}
                </div>
                <div className="space-y-1" data-id="element-797">
                  <h3 className="text-xl sm:text-2xl font-semibold text-neutral-900" data-id="element-798">
                    {stat.value}
                  </h3>
                  <p className="text-xs sm:text-sm text-neutral-600" data-id="element-799">
                    {stat.label}
                  </p>
                </div>
                <p className={`text-xs mt-2 sm:mt-3 ${stat.trendUp ? 'text-success' : 'text-error'}`} data-id="element-800">
                  {stat.trend}
                </p>
              </CardContent>
            </Card>)}
        </div>

        {/* System Health */}
        <Card data-id="element-801">
          <CardHeader data-id="element-802">
            <CardTitle className="flex items-center gap-2 text-base sm:text-lg" data-id="element-803">
              <Zap className="w-4 h-4 sm:w-5 sm:h-5 text-atios-primary" data-id="element-804" />
              Kesehatan Sistem
            </CardTitle>
          </CardHeader>
          <CardContent data-id="element-805">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4" data-id="element-806">
              {systemHealth.map((item, i) => <div key={i} className="p-3 sm:p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-all" data-id="element-807">
                  <div className="flex items-center justify-between mb-2" data-id="element-808">
                    <p className="text-xs sm:text-sm text-neutral-600" data-id="element-809">
                      {item.metric}
                    </p>
                    <div className="h-2 w-2 rounded-full bg-success" data-id="element-810"></div>
                  </div>
                  <p className="text-lg sm:text-xl font-semibold text-neutral-900" data-id="element-811">
                    {item.value}
                  </p>
                </div>)}
            </div>
          </CardContent>
        </Card>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8" data-id="element-812">
          {/* Pending Approvals */}
          <Card data-id="element-813">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-814">
              <CardTitle className="text-base sm:text-lg" data-id="element-815">
                Menunggu Persetujuan
              </CardTitle>
              <Button variant="link" className="text-atios-primary text-sm" onClick={() => navigate('/admin/approvals')} data-id="element-816">
                Lihat Semua
              </Button>
            </CardHeader>
            <CardContent data-id="element-817">
              <div className="overflow-x-auto -mx-4 sm:mx-0" data-id="element-818">
                <div className="inline-block min-w-full align-middle" data-id="element-819">
                  <Table data-id="element-820">
                    <TableHeader data-id="element-821">
                      <TableRow data-id="element-822">
                        <TableHead className="text-xs sm:text-sm" data-id="element-823">
                          Nama
                        </TableHead>
                        <TableHead className="text-xs sm:text-sm" data-id="element-824">
                          Tipe
                        </TableHead>
                        <TableHead className="text-xs sm:text-sm" data-id="element-825">
                          Tanggal
                        </TableHead>
                        <TableHead className="text-right text-xs sm:text-sm" data-id="element-826">
                          Aksi
                        </TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody data-id="element-827">
                      {pendingApprovals.map(item => <TableRow key={item.id} data-id="element-828">
                          <TableCell data-id="element-829">
                            <p className="font-medium text-xs sm:text-sm text-neutral-900" data-id="element-830">
                              {item.name}
                            </p>
                          </TableCell>
                          <TableCell data-id="element-831">
                            <Badge variant="default" className="text-xs" data-id="element-832">
                              {item.type}
                            </Badge>
                          </TableCell>
                          <TableCell className="text-neutral-600 text-xs sm:text-sm" data-id="element-833">
                            {item.date}
                          </TableCell>
                          <TableCell className="text-right" data-id="element-834">
                            <div className="flex justify-end gap-1 sm:gap-2" data-id="element-835">
                              <Button size="sm" variant="secondary" className="text-error hover:text-error text-xs" onClick={() => handleReject(item.id)} data-id="element-836">
                                Tolak
                              </Button>
                              <Button size="sm" onClick={() => handleApprove(item.id)} className="text-xs" data-id="element-837">
                                <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 sm:mr-1" data-id="element-838" />
                                <span className="hidden sm:inline" data-id="element-839">
                                  Setujui
                                </span>
                                <span className="sm:hidden" data-id="element-840">OK</span>
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Recent Activities */}
          <Card data-id="element-841">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-842">
              <CardTitle className="text-base sm:text-lg" data-id="element-843">
                Aktivitas Terbaru
              </CardTitle>
              <Button variant="link" className="text-atios-primary text-sm" onClick={() => navigate('/admin/activities')} data-id="element-844">
                Lihat Semua
              </Button>
            </CardHeader>
            <CardContent data-id="element-845">
              <div className="space-y-3 sm:space-y-4" data-id="element-846">
                {recentActivities.map((activity, i) => <div key={i} className="flex items-start gap-2 sm:gap-3 p-2 sm:p-3 rounded-lg hover:bg-neutral-50 transition-colors" data-id="element-847">
                    <div className="h-7 w-7 sm:h-8 sm:w-8 rounded-full bg-atios-light flex items-center justify-center text-atios-primary font-medium text-xs sm:text-sm flex-shrink-0" data-id="element-848">
                      {activity.user.charAt(0)}
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-849">
                      <p className="text-xs sm:text-sm text-neutral-900" data-id="element-850">
                        <span className="font-medium" data-id="element-851">{activity.user}</span>{' '}
                        {activity.action}{' '}
                        <span className="font-medium" data-id="element-852">{activity.target}</span>
                      </p>
                      <p className="text-xs text-neutral-500 mt-1" data-id="element-853">
                        {activity.time}
                      </p>
                    </div>
                  </div>)}
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Quick Actions */}
        <div data-id="element-854">
          <h2 className="text-base sm:text-lg font-semibold text-neutral-900 mb-4" data-id="element-855">
            Aksi Cepat
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4" data-id="element-856">
            {[{
            label: 'Kelola Pengguna',
            icon: Users,
            onClick: () => navigate('/admin/members')
          }, {
            label: 'Lihat Analitik',
            icon: BarChart,
            onClick: () => navigate('/admin/analytics')
          }, {
            label: 'Pengaturan Sistem',
            icon: Settings,
            onClick: () => navigate('/admin/settings')
          }, {
            label: 'Log Keamanan',
            icon: Shield,
            onClick: () => navigate('/admin/logs')
          }].map((action, i) => <Button key={i} variant="secondary" className="h-auto py-3 sm:py-4 flex flex-col gap-2 hover:border-atios-primary transition-all" onClick={action.onClick} data-id="element-857">
                <action.icon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-858" />
                <span className="text-xs sm:text-sm text-center" data-id="element-859">
                  {action.label}
                </span>
              </Button>)}
          </div>
        </div>
      </div>
    </div>;
}